var _path, _g, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelivery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 57,
    viewBox: "0 0 84 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2792_16843",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 84,
    height: 57
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H84V57H0V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2792_16843)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M83.2058 27.0224L69.5045 10.527C68.8635 9.7547 67.9226 9.31194 66.9241 9.31194H54.5951V3.39688C54.5951 1.52789 53.0851 0.0078125 51.2288 0.0078125H3.35798C1.50266 0.0078125 -0.00732422 1.52789 -0.00732422 3.39688V45.6929C-0.00732422 47.5619 1.50266 49.082 3.35798 49.082H10.1281C10.6203 53.5167 14.3633 56.9752 18.8953 56.9752C23.4273 56.9752 27.1693 53.5167 27.6625 49.082H51.2288C51.8425 49.082 52.4157 48.9136 52.9109 48.6239C53.4051 48.9126 53.9773 49.0809 54.589 49.0809H58.8395C59.3316 53.5157 63.0747 56.9752 67.6077 56.9752C72.1397 56.9752 75.8827 53.5157 76.3749 49.0809H80.6253C82.4807 49.0809 83.9896 47.5598 83.9896 45.6919V29.1964C83.9896 28.4017 83.7111 27.6284 83.2058 27.0224ZM3.35798 3.40198L51.2247 3.39688L51.2257 12.6806C51.2257 12.6877 51.2247 12.6939 51.2247 12.701V45.6878H27.3891C26.347 41.9498 22.9351 39.2004 18.8953 39.2004C14.8555 39.2004 11.4426 41.9508 10.4005 45.6888L3.36305 45.6929L3.35798 3.40198ZM18.8953 53.581C15.8875 53.581 13.4417 51.1172 13.4417 48.0883C13.4417 45.0594 15.8875 42.5946 18.8953 42.5946C21.9021 42.5946 24.3489 45.0594 24.3489 48.0883C24.3489 51.1172 21.9021 53.581 18.8953 53.581ZM67.6077 53.581C64.5999 53.581 62.1531 51.1172 62.1531 48.0883C62.1531 45.0594 64.5999 42.5946 67.6077 42.5946C70.6145 42.5946 73.0612 45.0594 73.0612 48.0883C73.0612 51.1172 70.6145 53.581 67.6077 53.581ZM76.1015 45.6858C75.0583 41.9488 71.6465 39.2004 67.6077 39.2004C63.5679 39.2004 60.156 41.9498 59.1129 45.6878L54.5951 45.6919V12.7061L66.919 12.7051L80.6193 29.1964L80.6253 45.6858H76.1015Z",
    fill: "#FDFEFE"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M66.6388 16.4518C66.3187 16.0662 65.8468 15.8438 65.3485 15.8438H57.9495C57.0209 15.8438 56.2694 16.6007 56.2694 17.5352V25.9946C56.2694 26.9291 57.0209 27.6861 57.9495 27.6861H72.3465C73.7704 27.6861 74.5482 26.013 73.6367 24.9112L66.6388 16.4518Z",
    fill: "#FDFEFE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelivery);
export default __webpack_public_path__ + "static/media/delivery.50d1cea0569ea739de0f5d3dd2d305d2.svg";
export { ForwardRef as ReactComponent };